import posts from './posts'
import taxonomy from './taxonomy'
import media from './media'

const blog = {
    posts: Object.assign(posts, posts),
    taxonomy: Object.assign(taxonomy, taxonomy),
    media: Object.assign(media, media),
}

export default blog